import React, { useState, useEffect } from 'react';

const TypingBackground = () => {
  const codeLines = React.useMemo(() => [
    `const firewallRulesSet = ['ALLOW_HTTP', 'BLOCK_FTP', 'ALLOW_SSH', 'DENY_TELNET'];`,
    `const intrusionDetectionActive = true && false || true && !false; `,
    `const encryptionAlgorithmName = 'AES-256-CBC-SHA512-HMAC-KEYGEN';`,
    `function simulateAttack() {`,
    `\t console.log('Simulating cyber attack for testing firewallRulesSet array.');`,
    `\t if (!intrusionDetectionActive) {`,
    `\t \t console.log('Intrusion detection is currently disabled!');`,
    `\t }`,
    `}`,
  ], []);

const [displayedLines, setDisplayedLines] = useState([]);
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout;

    if (!isDeleting && lineIndex === codeLines.length) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
        setLineIndex(lineIndex - 1);
        setCharIndex(codeLines[lineIndex - 1].length);
      }, 1500);
      return () => clearTimeout(timeout);
    }

    if (isDeleting && lineIndex < 0) {
      timeout = setTimeout(() => {
        setIsDeleting(false);
        setLineIndex(0);
        setCharIndex(0);
        setDisplayedLines([]);
      }, 1000);
      return () => clearTimeout(timeout);
    }

    if (!isDeleting) {
      const currentLine = codeLines[lineIndex] || '';
      if (charIndex <= currentLine.length) {
        timeout = setTimeout(() => {
          const updatedLines = [...displayedLines];
          updatedLines[lineIndex] = currentLine.slice(0, charIndex);
          setDisplayedLines(updatedLines);
          setCharIndex(charIndex + 1);
        }, 40);
      } else {
        timeout = setTimeout(() => {
          setLineIndex(lineIndex + 1);
          setCharIndex(0);
        }, 300);
      }
    } else {
      const currentLine = displayedLines[lineIndex] || '';
      if (charIndex >= 0) {
        timeout = setTimeout(() => {
          const updatedLines = [...displayedLines];
          updatedLines[lineIndex] = currentLine.slice(0, charIndex);
          setDisplayedLines(updatedLines);
          setCharIndex(charIndex - 1);
        }, 30);
      } else {
        timeout = setTimeout(() => {
          setLineIndex(lineIndex - 1);
          setCharIndex(displayedLines[lineIndex - 1]?.length || 0);
        }, 200);
      }
    }

    return () => clearTimeout(timeout);
  }, [charIndex, lineIndex, isDeleting, displayedLines, codeLines]);

  return (
    <div style={{ whiteSpace: 'pre' }} className="fixed top-[15%] left-[15%] z-0 max-w-6xl pointer-events-none font-mono">
      <div className="text-left text-sm md:text-2xl font-bold text-blue-400 opacity-30 drop-shadow-[0_0_12px_rgba(59,130,246,0.7)] select-none leading-relaxed">
        {displayedLines.map((line, idx) => (
          <div key={idx}>
            {line}
            {idx === lineIndex && <span className="animate-blink">_</span>}
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
          .animate-blink {
            animation: blink 1s step-start infinite;
          }
        `}
      </style>
    </div>
  );
};

export default TypingBackground;
